// Runtime-safe wrapper for Vite's import.meta.glob — returns an empty record
// when running under non-Vite bundlers (webpack/react-scripts) to avoid
// runtime TypeErrors and TypeScript complaints about possibly-undefined.
export function safeGlob<T = string>(pattern: string | string[], options?: any): Record<string, T> {
  // In Vite builds `import.meta.glob` is handled at build-time. To avoid
  // emitting the `import.meta` token (which causes a runtime SyntaxError
  // under non-module/webpack output), this helper does NOT reference
  // `import.meta` directly. When running under non-Vite toolchains we
  // return an empty record so consumers degrade gracefully.
  //
  // NOTE: If Vite's build-time transform is active it will have replaced
  // the original `import.meta.glob` calls in the component source with a
  // static object before this module is executed; in that case the
  // components will not call `safeGlob` at runtime. Returning an empty
  // record here is safe for webpack/CRA builds.
  return {} as Record<string, T>;
}

export default safeGlob;
